/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import {
  PanelType,
  SelectionMode,
  DefaultButton,
  Panel
} from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";
import useAxios from 'axios-hooks';
import CobrandSettingsForm from './CobrandSettingsForm';
import FeatureSummary from "../../../../Util/FeatureSummary";

const displayModeText = {
  1: "Show",
  2: "Hide",
  3: "Trigger",
};
const warning = css`
    color: #e00000;
    font-weight: 500;
`;

const SettingsTable = ({ cobrandIdList }) => {
  const [items, setItems] = useState([]);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [{ data, loading }, getSettings] = useAxios({ method: 'POST', url: 'courses/crs-settings' },{ manual: true });

  const fetchData = async () =>{
    var result = await getSettings({
      data: { cobrandIdList: cobrandIdList.map(x => x.coBrandId).join(',') },
      method: 'POST',
      url: 'courses/crs-settings',
    });
    if (!result.isAxiosError) {
      setItems(result.data);
    }
  }
  useEffect(() => {
    if(!items.length){
      fetchData()
    }
   
  }, []);

  const openPanel = (item) => {
    setSelectedItem(item);
    setIsPanelOpen(true);
  };

  const closePanel = () => {
    setIsPanelOpen(false);
    setSelectedItem(null);
  };

  const columns = [
    { key: "CRSID", name: "ID", fieldName: "crsid", minWidth: 50, maxWidth: 50 },
    {
      key: "crsTitle",
      name: "Course Title",
      fieldName: "crsTitle",
      minWidth: 150,
      maxWidth: 200,
    },
    {
      key: "crsUrl",
      name: "URL",
      minWidth: 200,
      onRender: (item) => (
        <a href={item.CRSUrl} target="_blank" rel="noopener noreferrer">
          {item.crsUrl}
        </a>
      ),
    },
    {
      key: "crsDisplayModeID",
      name: "Show/Hide/Trigger",
      minWidth: 150,
      onRender: (item) => {
      return <div>{!item.crsDisplayModeIDIsMatch ? <div css={warning}>Mixed</div> :  (displayModeText[item.crsDisplayModeID] || "")}</div>},
    },
    {
      key: "edit",
      name: "Course Specific Settings",
      minWidth: 170,
      onRender: (item) => (
        <DefaultButton text="Edit more settings" onClick={() => openPanel(item)} />
      ),
    },
  ];


  return (
    <>
      {!loading && <>
        <DetailsTable
          items={items}
          loading={loading}
          columns={columns}
          selectionHook={() => {}}
          mainColumn={'CRSID'}
          detailsListProps={{ selectionMode: SelectionMode.none }}
          style={{
            position: 'relative',
            height: '80vh',
            width: '80vw',
          }}
        />
        <FeatureSummary
          label="About Course Cobrand Settings"
          summary="This table displays all course settings for selected cobrands, including display modes and URLs. You can edit course-specific settings. This feature allows admins to configure course visibility and options for each cobrand."
          imageUrlPath='course-specific'
        />
      </>}

      <Panel
        isOpen={isPanelOpen}
        onDismiss={closePanel}
        headerText={selectedItem ? `Edit Settings: ${selectedItem.crsTitle}` : "Edit Settings"}
        closeButtonAriaLabel="Close"
        customWidth={480}
        type={PanelType.custom}
        styles={{
          main: {
            top: 20,
            right: 20,
            bottom: 20,
            position: "absolute",
            borderRadius: "10px", // Rounded corners
            overflow: "hidden", // Prevents inner content overflow on rounded edges
          },
        }}
      >
        <CobrandSettingsForm initialData={selectedItem} fetchData={fetchData} />
      </Panel>
    </>
  );
};

export default SettingsTable;
